var _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackflag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 72 72",
    id: "emoji",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "skin"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "skin-shadow"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    stroke: "none",
    d: "M22.3025,17.488c2.958-1.7983,8.6348-4.2326,14.7802-1.488c3.7823,1.6892,5.7769,4.6976,15.4209,4.1142 C53.3121,20.0653,54,20.7109,54,21.5248c0,3.3025,0,11.1393,0,15.1253c0,0.6226-0.4342,1.0771-0.9892,1.354 C51.0146,39,45.5555,38.939,37.0827,35c-3.4504-1.6041-8.7871-2.5683-14.8238,1.4425"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M23.0844,17.488C25.9694,15.6897,31.5062,13.2554,37.5,16c3.689,1.6892,5.6344,4.6976,15.0405,4.1142 C53.3291,20.0653,54,20.7109,54,21.5248c0,3.3025,0,11.1393,0,15.1253c0,0.6226-0.4235,1.0771-0.9648,1.354 C51.0882,39,45.7637,38.939,37.5,35c-3.3653-1.6041-8.5703-2.5683-14.4582,1.4425"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.3271,
    x2: 19.3271,
    y1: 12.875,
    y2: 59.8348,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackflag);
export default __webpack_public_path__ + "static/media/blackflag.c13db11db2a09be69c59711cee94d10f.svg";
export { ForwardRef as ReactComponent };